import { Grid } from '@mantine/core';

interface Props {
  xl?: number;
  lg?: number;
  md?: number;
  sm?: number;
  xs?: number;
  disappearAtSmallerThan: 'xl' | 'lg' | 'md' | 'sm' | 'xs';
}

const XColEmpty = (props: Props) => {
  const { xl, lg, md, sm, xs, disappearAtSmallerThan } = props;
  return (
    <Grid.Col
      xl={xl}
      lg={lg}
      md={md}
      sm={sm}
      xs={xs}
      sx={(theme) => {
        return {
          [theme.fn.smallerThan(disappearAtSmallerThan)]: { display: 'none' },
        };
      }}
    ></Grid.Col>
  );
};

export default XColEmpty;
